<template lang="html">
	<div class="claim-box">
		<div class="date-box clearfix">
			<div class="txt f-l">Reported On:</div>
			<div class="date f-l">
				{{
					moment(claim.report_details.report_date).format(
						'Do MMM YYYY',
					)
				}}
			</div>
			<div class="status f-r">{{ claim.claim_decision }}</div>
		</div>
		<div class="clearfix">
			<div class="name-box f-l">
				<div class="insurance link" @click="$emit('view-claim')">
					{{ claim.system_claim_ref || '-' }}
				</div>
				<div class="txt">Product ID: {{ claim.product_id }}</div>
				<div class="txt">
					Policy Number: {{ claim.client_product_id }}
				</div>
				<div class="txt">
					Ref: {{ claim.system_claim_ref.toUpperCase() }}
				</div>
				<!-- <div class="categories clearfix">
                    <div class="category f-l" v-for="category in claim.categories">
                        <div class="name f-l">{{category}}</div>
                        <div class="circle f-l"></div>
                    </div>
                    </div> -->
			</div>
			<div class="action f-r">
				<div
					class="btn btn-primary"
					v-if="claim.claim_category_stage === 'REPORT'"
					@click="makeClaim(claim)"
				>
					Make Claim
					<div class="lds-ring" v-show="loading">
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		claim: {
			default: function () {
				return {
					report_details: {
						report_details: '2020-08-14T12:39:47.247Z',
					},
					product_id: 512,
					claim_decision: 'PENDING',
					claim_type: 'ACCIDENT',
				};
			},
		},
	},
	methods: {
		async makeClaim(claim) {
			try {
				this.$store.commit('loading', true);
				await this.$store.dispatch('viewClaim', {
					claim,
					is_select: true,
				});
				await this.$store.dispatch('makeClaim');
				this.$store.commit('loading', false);
			} catch (err) {
				this.$store.commit('loading', false);
			}
		},
	},
	computed: {
		...mapGetters(['loading']),
	},
	data() {
		return {
			utils,
			moment,
		};
	},
	mounted() {},
};
</script>

<style lang="less">
@grey: #a7abbd;

.claim-box {
	border-radius: 4px;
	border: solid 1px #e6eaee;
	background: var(--white);
	padding: 20px 15px;
	margin: 5px 0 !important;

	.insurer {
		color: var(--ne-blue);
		font-weight: 600;
		font-size: 12px;
	}

	.link {
		color: var(--ne-primary);
		text-decoration: underline;
		cursor: pointer;

		&:hover {
			color: var(--ne-blue);
		}
	}

	.date-box {
		margin: -1px 15px 0 0;
		width: 100%;

		.status {
			font-size: 11px;
			text-align: right;
		}
		.txt {
			font-size: 13px;
			margin: 4px 5px 15px 0;
		}

		.month,
		.year {
			color: @grey;
			font-size: 14px;
			font-weight: 600;
			line-height: 12px;
			margin: 8px 5px;
		}

		.date {
			font-size: 14px;
			font-family: var(--font-bold);
			color: var(--text-color);
			margin: 4px 0 2px 5px;
		}
	}

	.name-box {
		.insurance {
			font-size: 17px;
			color: var(--text-color);
			font-family: var(--font-bold);
			text-transform: uppercase;
			line-height: 15px;
		}

		.txt {
			font-weight: 600;
			color: @grey;
			font-size: 13px;
		}
	}

	.categories {
		margin: 10px 0 0 0;

		.category:last-child {
			.circle {
				display: none;
			}
		}

		.name {
			font-weight: 600;
			color: #9c7bfc;
			font-size: 13px;
		}

		.circle {
			width: 4px;
			height: 4px;
			border-radius: 50%;
			background: #9c7bfc;
			margin: 11px 10px 0 10px;
		}
	}

	.price-box {
		.price {
			font-size: 20px;
			line-height: 15px;
			font-family: var(--font-bold);
			margin: 5px 0 0 0;

			.point {
				font-size: 11px;
			}
		}

		.txt {
			font-weight: 600;
			color: @grey;
		}
	}
}
</style>
